import React from 'react';

export default function Spinner() {
  return (
    <div className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-50">
      <div className="relative w-20 h-6 flex items-center">
        {/* Pink Circle */}
        <div
          className="w-6 h-6 rounded-full bg-pink-500 absolute"
          style={{
            animation: 'moveLeftRight 1.2s ease-in-out infinite, glowPink 1.2s ease-in-out infinite',
          }}
        />
        {/* Light Blue Circle */}
        <div
          className="w-6 h-6 rounded-full bg-blue-400 absolute"
          style={{
            animation: 'moveRightLeft 1.2s ease-in-out infinite, glowBlue 1.2s ease-in-out infinite',
          }}
        />
      </div>
    </div>
  );
}

// Add CSS animations in a style tag or external stylesheet
const styles = `
  @keyframes moveLeftRight {
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(56px);
    }
    100% {
      transform: translateX(0);
    }
  }

  @keyframes moveRightLeft {
    0% {
      transform: translateX(56px);
    }
    50% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(56px);
    }
  }

  @keyframes glowPink {
    0% {
      box-shadow: 0 0 5px #FF2D55, 0 0 10px #FF2D55;
    }
    50% {
      box-shadow: 0 0 10px #FF2D55, 0 0 15px #FF2D55;
    }
    100% {
      box-shadow: 0 0 5px #FF2D55, 0 0 10px #FF2D55;
    }
  }

  @keyframes glowBlue {
    0% {
      box-shadow: 0 0 5px #00C4FF, 0 0 10px #00C4FF;
    }
    50% {
      box-shadow: 0 0 10px #00C4FF, 0 0 15px #00C4FF;
    }
    100% {
      box-shadow: 0 0 5px #00C4FF, 0 0 10px #00C4FF;
    }
  }
`;

// Inject the styles into the document
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);